import leaves from '../../../../assets/Images/Types/leaves.png';
import cup from '../../../../assets/Images/Types/cup.png';
import paper from '../../../../assets/Images/Types/paper.png';

export const types = [
  {
    id: 1,
    img: paper,
    title:
      "Donec sed orci fermentum, convallis lacus id, tempus elit. Sed eu neque accumsan, porttitor arcu a, interdum est. Donec in risus eu ante.",
    buttonColor: "#2D99CC",
  },
  {
    id: 2,
    img: leaves,
    title:
      "Maecenas pretium rutrum molestie. Duis dignissim egestas turpis sit. Nam sed suscipit odio. Morbi in dolor finibus, consequat nisl eget.",
    buttonColor: "#319966",
  },
  {
    id: 3,
    img: cup,
    title:
      "Morbi in dolor finibus, consequat nisl eget, pretium nunc. Maecenas pretium rutrum molestie. Duis dignissim egestas turpis sit.",
    buttonColor: "#993332",
  },
];
